module.exports = function(options) {
  if(!options.model.get('path')) {
    console.warn('Found a custom block view, but there was no path to require from. Specify a path using the path property');
  } else {
    const ImportView = require(options.model.get('path'));
    return new ImportView(options);
  }
};
